import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import { queryKeys } from "../../query-keys";

export function useClubSkillLevels(clubId: string | undefined) {
	return useQuery({
		queryKey: queryKeys.clubPortal.skillLevels(clubId ?? ""),
		queryFn: () => clubApi.skillLevels.list(clubId as string),
		enabled: !!clubId,
	});
}

export function useCreateSkillLevel(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (data: { name: string; sort_order?: number }) =>
			clubApi.skillLevels.create(clubId, data),
		// Returned so callers selecting the new level in onSuccess find it in the refreshed list.
		onSuccess: () =>
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.skillLevels(clubId),
			}),
	});
}

export function useUpdateSkillLevel(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({
			levelId,
			data,
		}: {
			levelId: string;
			data: { name?: string; sort_order?: number };
		}) => clubApi.skillLevels.update(clubId, levelId, data),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.skillLevels(clubId),
			});
		},
	});
}

export function useDeleteSkillLevel(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (levelId: string) => clubApi.skillLevels.delete(clubId, levelId),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.skillLevels(clubId),
			});
		},
	});
}
